import { useTranslation } from 'react-i18next';
import CustomInput from '../../../components/CustomInput';
import DefaultTooltip from '../../../components/DefaultTooltip';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import { CustomAdvancedMenuList, CustomSecondaryButton, NormalSwitch, StyledDataGrid } from '../../../components/StyledComponents';
import RefreshCircleIcon20pxSvgV2 from '../../../assets/images/icons/RefreshCircleIcon20pxSvgV2';
import CustomSelect from '../../../components/CustomSelect';
import CustomTimePickerHaveSecondV2 from '../../../components/CustomTimePickerHaveSecondV2';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { generateTranslateMuiTable } from '../../../utils/Function/commonFunction';
import EditNew20pxSvg from '../../../assets/images/icons/EditNew20pxSvg';
import DeleteIcon16pxSvg from '../../../assets/images/icons/DeleteIcon16pxSvg';
import CustomColumnsPanel from '../../../components/CustomColumnsPanel';
import NoRowOverlay from '../../../assets/images/icons/NoRowOverlay';
import { ControlpanelPrimaryButton } from '../../../components/StyledButton';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CustomGridToolbarQuickFilterNew2 from '../CustomGridToolbarQuickFilterNew2';
import AddIcon from '@mui/icons-material/Add';
import CustomSplitButton from '../../../components/CustomSplitButton';
import CloudArrowUpIcon16pxSvg from '../../../assets/images/icons/CloudArrowUpIcon16pxSvg';
import CloudArrowDownIcon16pxSvg from '../../../assets/images/icons/CloudArrowDownIcon16pxSvg';
import {
    ClickAwayListener,
    Grow,
    Link,
    MenuItem,
    Paper,
    Popper,
} from "@mui/material";
import ImportIcon20pxSvg from '../../../assets/images/icons/ImportIcon20pxSvg';
import ExportIcon20pxSvg from '../../../assets/images/icons/ExportIcon20pxSvg';
import AddLocationDialog from './AddLocationDialog';
import { getListLocations } from '../../../axios/Setting/SettingUrlApi';
import { useAuth } from '../../../context/AuthContext';
import { toast } from 'react-toastify';
import EditLocationDialog from './EditLocationDialog';
import RemoveLocationDialog from './RemoveLocationDialog';
import ImportIcon16pxSvg from '../../../assets/images/icons/ImportIcon16pxSvg';
export const AttendanceLeaveTab = ({ handleResetWebSetting, settingKeyMap, debouncedAutoSave, handleDataChange, refreshData, handleRefresh, leaveTypesData, defaultShiftSelectionBehaviourData, handleInputChange, formData, handleResetSetting, getAttrTypeId, getSettingTitle, getSettingEntityTitle }) => {
    const { t } = useTranslation();

    const leaveTypeSelectOptions = useMemo(
        () => [
            {
                leaveTypeId: 1,
                leaveTypeName: t("common.no-selection"),
                remark: t("common.no-selection"),
                remarkEN: t("common.no-selection"),
            },
            // {
            //     leaveTypeId: 0,
            //     leaveTypeName: t("common.no-selection"),
            //     remark: t("common.no-selection"),
            //     remarkEN: t("common.no-selection"),
            // },
            ...(leaveTypesData || []),
        ],
        [leaveTypesData, t]
    );

    const toLeaveTypeSelectValue = (raw) =>
        raw === null ||
        raw === undefined ||
        raw === "" ||
        Number.isNaN(Number(raw))
            ? 0
            : Number(raw);

    const leaveTypeSelectValue = toLeaveTypeSelectValue(formData.leaveType);
    const excludedLeaveTypeSelectValue = toLeaveTypeSelectValue(
        formData.leaveTypeWithoutPermission
    );

    const handleLeaveTypeFieldChange = (fieldName) => (e) => {
        const raw = e?.target?.value;
        const nextValue =
            raw === "" || raw === null || raw === undefined
                ? 0
                : Number(raw);

        handleInputChange({
            target: {
                name: fieldName,
                value: nextValue,
            },
        });
    };

    const handleLeaveTypeChange = handleLeaveTypeFieldChange("leaveType");
    const handleExcludedLeaveTypeChange = handleLeaveTypeFieldChange(
        "leaveTypeWithoutPermission"
    );
    const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);
    const [addLocationsOpen, setAddLocationsOpen] = useState(false);
    const [editLocationsOpen, setEditLocationsOpen] = useState(false);
    const [rowSelect, setRowSelect] = useState([]);
    const [gridLoading, setGridLoading] = useState(false);
    const anchorRefAdvanced = useRef(null);
    const [openAdvanced, setOpenAdvanced] = useState(false);
    const [locations, setLocations] = useState([])
    const { profile } = useAuth();
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [removeLocationOpen, setRemoveLocationOpen] = useState(false);

    const handleCloseRemoveLocation = () => {
        setRemoveLocationOpen(false);
    };

    const handleOpenRemoveLocation = () => {
        setRemoveLocationOpen(true);
    };

    const handleToggleAdvanced = () => {
        setOpenAdvanced((prev) => !prev);
    };

    const handleCloseAdvanced = (event) => {
        if (
            anchorRefAdvanced.current &&
            anchorRefAdvanced.current.contains(event.target)
        ) {
            return; // click vào button thì không close
        }
        setOpenAdvanced(false);
    };

    const handleCloseAddLocations = () => {
        setAddLocationsOpen(false);
    };

    const handleOpenAddLocations = () => {
        setAddLocationsOpen(true)
    }

    const handleCloseEditLocations = () => {
        setEditLocationsOpen(false);
    };

    const handleOpenEditLocations = () => {
        setEditLocationsOpen(true)
    }

    const handleQuickFilterChange = (searchText) => {
        // const lowerSearch = searchText.toLowerCase();
        // const filtered = rowData.filter((row) =>
        //     Object.values(row).some((val) =>
        //         String(val).toLowerCase().includes(lowerSearch)
        //     )
        // );
        // setRowData(filtered);
    };

    useEffect(() => {
        const fetchDataLocations = async () => {
            try {
                const response = await getListLocations({ id: profile.companyId, langId: localStorage.getItem("i18nextLngId") });
                setLocations(response.data.data)
            } catch (error) {
                if (error.response) {
                    if (error.response.status !== 401) {
                        toast.error(t(error?.response.data));
                    }
                } else {
                    toast.error(t('common.network-timeout'));
                }
            }
        };

        fetchDataLocations();
    }, [refreshData]);

    const templateToolbar = useCallback(
        () => (
            <div className="flex items-center gap-3 mb-2 h-10">
                {/* SEARCH */}
                <div className="flex-1 min-w-0 h-10 flex items-center">
                    <CustomGridToolbarQuickFilterNew2
                        onSearchChange={handleQuickFilterChange}
                    />
                </div>

                <div className="opacity-50 pointer-events-none shrink-0 h-10 flex items-center">
                    <CustomSplitButton
                        label={t("button.add")}
                        startIcon={<AddIcon className="!text-[16px]" />}
                        onMainClick={handleOpenAddLocations}
                        onDropdownClick={handleToggleAdvanced}
                        ref={anchorRefAdvanced}
                    />
                </div>
            </div>
        ),
        [t]
    );

    const columnData = [
        { field: 'locationName', headerName: t('common.name'), hideable: true, flex: 1, },
        { field: 'address', headerName: t('common.address'), hideable: true, flex: 1, },
        { field: 'latitude', headerName: t('common.latitude'), hideable: true, flex: 1, },
        { field: 'longitude', headerName: t('common.longitude'), hideable: true, flex: 1, },
        { field: 'radius', headerName: t('common.radius'), hideable: true, flex: 1, },
        {
            field: "options",
            headerName: t("common.options"),
            sortable: false,
            filterable: false,
            minWidth: 200,
            renderCell: (params) => (
                <div
                    className="flex gap-2 items-center justify-start h-full"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* EDIT */}
                    <button
                        className="p-2 rounded-lg hover:bg-gray-100 transition cursor-pointer"
                        onClick={() => {
                            setSelectedLocation(params.row);   // ✅ lưu row
                            handleOpenEditLocations();         // mở dialog
                        }}
                    >
                        <EditNew20pxSvg className="w-5 h-5" />
                    </button>

                    {/* DELETE */}
                    <button
                        className="p-2 rounded-lg hover:bg-red-100 transition cursor-pointer"
                    // onClick={() => handleOpenDeleteRecipients(params.row)}
                    >
                        <DeleteIcon16pxSvg className="w-5 h-5" color="#D00D00" onClick={() => {
                            setSelectedLocation(params.row);   // ✅ lưu row
                            handleOpenRemoveLocation();        // mở dialog
                        }} />
                    </button>
                </div>
            )
        },

    ];

    const generateDaysOfYear = () => {
        const days = [];
        const date = new Date(2024, 0, 1); // năm bất kỳ

        const monthKeys = [
            "months.january",
            "months.february",
            "months.march",
            "months.april",
            "months.may",
            "months.june",
            "months.july",
            "months.august",
            "months.september",
            "months.october",
            "months.november",
            "months.december",
        ];

        while (date.getFullYear() === 2024) {
            const day = date.getDate();
            const monthIndex = date.getMonth();

            days.push({
                label: `${day} ${t(monthKeys[monthIndex])}`,
                value: `${day}-${monthIndex + 1}`,
            });

            date.setDate(date.getDate() + 1);
        }

        return days;
    };
    return (
        <>
            <div className='space-y-4'>
                <div className="
                    grid
                    2xl:grid-cols-2
                    grid-cols-1
                    gap-0
                    items-stretch
                    ">
                    <div className="2xl:pr-2 flex">
                        <div className='bg-[#F9FAFB] p-4 rounded-[16px] space-y-3 w-full h-full' data-tour="setting-attendance">
                            <h2 className='font-semibold'>{getSettingEntityTitle("Timekeeping request expiration time", "common.attendance")}</h2>

                            <div className="flex md:flex-row flex-col md:items-center items-start gap-2 justify-between py-2">
                                {/* LEFT */}
                                <div className="flex items-center gap-2">
                                    <p>{t("common.allowEmployeeToAttendace")}</p>
                                    <DefaultTooltip
                                        title={t("common.allowEmployeeToAttendace")}
                                        readMore={false}
                                        content={
                                            <div className="flex flex-col gap-3">
                                                <p>{t("common.allowEmployeeToAttendace")}.</p>
                                            </div>
                                        }
                                    >
                                        <div>
                                            <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                        </div>
                                    </DefaultTooltip>
                                </div>

                                {/* RIGHT */}
                                <div className="flex items-center gap-6">
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            className="w-5 h-5"
                                            type="checkbox"
                                            name="allowAttendanceWeb"
                                            disabled
                                        // checked={formData.allowAttendanceWeb}
                                        // onChange={handleInputChange}
                                        />
                                        <span>Web</span>
                                    </label>
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            className="w-5 h-5"
                                            type="checkbox"
                                            name="allowAttendanceMobile"
                                            disabled
                                        // checked={formData.allowAttendanceMobile}
                                        // onChange={handleInputChange}
                                        />
                                        <span>Mobile</span>
                                    </label>
                                </div>
                            </div>

                            <div className="space-y-1">
                                <div className="flex items-center gap-2">
                                    <p>{getSettingTitle("Timekeeping request expiration time", "common.timekeeping-request-expiration-time")}</p>
                                    <DefaultTooltip
                                        title={getSettingTitle("Timekeeping request expiration time", "common.timekeeping-request-expiration-time")}
                                        readMore={false}
                                        content={
                                            <div className="flex flex-col gap-3">
                                                <p>{t("common.timekeeping-des")}.</p>
                                            </div>
                                        }
                                    >
                                        <div>
                                            <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                        </div>
                                    </DefaultTooltip>
                                </div>

                                <div className="flex items-center gap-3">
                                    <div className="flex-1">
                                        <CustomInput
                                            name="timekeepingRequestExpirationTime"
                                            value={formData.timekeepingRequestExpirationTime}
                                            handleInputChange={handleInputChange}
                                            inputType="number"
                                            className="w-full"
                                            readOnly={false}
                                            minValue={-1}
                                            labelEnable={false}
                                        />
                                    </div>

                                    <CustomSecondaryButton
                                        onClick={() =>
                                            handleResetSetting(
                                                getAttrTypeId("Timekeeping request expiration time"),
                                                "timekeepingRequestExpirationTime"
                                            )
                                        }
                                    >
                                        <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                                    </CustomSecondaryButton>
                                </div>
                            </div>

                            <div className="space-y-1">
                                <div className="flex items-center gap-2">
                                    <p>{getSettingTitle("Default shift selection behaviour ", "common.default-shift-selection-behaviour")}</p>
                                    <DefaultTooltip
                                        title={getSettingTitle("Default shift selection behaviour ", "common.default-shift-selection-behaviour")}
                                        readMore={false}
                                        content={
                                            <div className="flex flex-col gap-3">
                                                <p>{t("common.general-setting-question-9")}.</p>
                                            </div>
                                        }
                                    >
                                        <div>
                                            <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                        </div>
                                    </DefaultTooltip>
                                </div>

                                <div className="flex items-center gap-3">
                                    <div className="flex-1">
                                        <CustomSelect
                                            name="defaultShiftSelectionBehaviour"
                                            value={formData.defaultShiftSelectionBehaviour}
                                            onChange={handleInputChange}
                                            options={defaultShiftSelectionBehaviourData}
                                            className="w-full"
                                            readOnly={true}
                                        />
                                    </div>

                                    <CustomSecondaryButton
                                        className='pointer-events-none opacity-50'
                                        onClick={() =>
                                            handleResetSetting(
                                                getAttrTypeId("Default shift selection behaviour "),
                                                "defaultShiftSelectionBehaviour"
                                            )
                                        }
                                    >
                                        <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                                    </CustomSecondaryButton>
                                </div>
                            </div>

                            <div className="space-y-1">
                                <div className="flex items-center gap-2">
                                    <p>{getSettingTitle("Unidentified eventlog count to keep.", "common.unidentified-eventlog-count-to-keep")}</p>
                                    <DefaultTooltip
                                        title={getSettingTitle("Unidentified eventlog count to keep.", "common.unidentified-eventlog-count-to-keep")}
                                        readMore={false}
                                        content={
                                            <div className="flex flex-col gap-3">
                                                <p>{t("common.general-setting-question-12")}.</p>
                                            </div>
                                        }
                                    >
                                        <div>
                                            <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                        </div>
                                    </DefaultTooltip>
                                </div>

                                <div className="flex items-center gap-3">
                                    <div className="flex-1">
                                        <CustomInput
                                            name="unidentifiedEventlogCountToKeep"
                                            value={formData.unidentifiedEventlogCountToKeep}
                                            handleInputChange={handleInputChange}
                                            inputType="number"
                                            className="w-full"
                                            minValue={-1}
                                            labelEnable={false}
                                            readOnly={true}
                                        />
                                    </div>

                                    <CustomSecondaryButton
                                        className='pointer-events-none opacity-50'
                                        onClick={() =>
                                            handleResetSetting(
                                                getAttrTypeId("Unidentified eventlog count to keep."),
                                                "unidentifiedEventlogCountToKeep"
                                            )
                                        }
                                    >
                                        <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                                    </CustomSecondaryButton>
                                </div>
                            </div>

                            <div className="flex items-center justify-between py-2 gap-6">
                                {/* LEFT: Label + Tooltip */}
                                <div className="flex items-center gap-2">
                                    <p className="">
                                        {getSettingTitle("Auto checkout at the end of the shift.", "common.auto-checkout-at-the-end-of-the-shift")}
                                    </p>

                                    <DefaultTooltip
                                        title={getSettingTitle("Auto checkout at the end of the shift.", "common.auto-checkout-at-the-end-of-the-shift")}
                                        readMore={false}
                                        content={
                                            <div className="flex flex-col gap-3">
                                                <p>{t("common.general-setting-question-10")}.</p>
                                            </div>
                                        }
                                    >
                                        <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                    </DefaultTooltip>
                                </div>

                                {/* RIGHT: Enable + Switch + Reset */}
                                <div className="flex items-center gap-4 shrink-0">

                                    <NormalSwitch

                                        name="autoCheckoutAtTheEndOfTheShift"
                                        checked={formData.autoCheckoutAtTheEndOfTheShift}
                                        onChange={(e) => {
                                            handleInputChange(e, "default");
                                        }}
                                        disabled
                                    />

                                    <CustomSecondaryButton
                                        className='pointer-events-none opacity-50'
                                        onClick={() =>
                                            handleResetSetting(
                                                getAttrTypeId("Auto checkout at the end of the shift."),
                                                "autoCheckoutAtTheEndOfTheShift"
                                            )
                                        }
                                    >
                                        <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                                    </CustomSecondaryButton>
                                </div>
                            </div>
                            <div className='space-y-1'>
                                <div className="flex items-center gap-1">
                                    <p>{getSettingTitle("Mobile attendance within internal IP network", "common.mobile-ip-network")}</p>
                                    <div>
                                        <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                    </div>
                                    <DefaultTooltip
                                        title={getSettingTitle("Mobile attendance within internal IP network", "common.mobile-ip-network")}
                                        readMore={false}
                                        content={
                                            <div className="flex flex-col gap-3">
                                                <p>{t("common.mobile-ip-network-des")}.</p>
                                            </div>
                                        }
                                    >

                                    </DefaultTooltip>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div className="flex-1"><CustomInput
                                        name="mobileAttendanceWithinInternalIPNetwork"
                                        value={formData.mobileAttendanceWithinInternalIPNetwork}
                                        handleInputChange={(e) => handleInputChange(e)}
                                        inputType="text"
                                        className="flex-1 w-full"
                                        readOnly={false}
                                        labelEnable={false}
                                    /></div>


                                    <CustomSecondaryButton
                                        onClick={() =>
                                            handleResetWebSetting(
                                                getAttrTypeId("Mobile attendance within internal IP network"),
                                                "mobileAttendanceWithinInternalIPNetwork"
                                            )
                                        }
                                    >
                                        <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                                    </CustomSecondaryButton>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="2xl:pl-2 flex">
                        <div className='bg-[#F9FAFB] p-4 rounded-[16px] space-y-3 w-full h-full' data-tour="setting-leave">
                            <h2 className='font-semibold'>{getSettingEntityTitle("Allow automatic approval of leave requests", "common.leave")}</h2>

                            <div className="flex items-center justify-between gap-6">
                                {/* LEFT: Label + Tooltip */}
                                <div className="flex items-center gap-2">
                                    <p className="">
                                        {getSettingTitle("Allow automatic approval of leave requests", "common.automatic-leave-approval")}
                                    </p>

                                    <DefaultTooltip
                                        title={getSettingTitle("Allow automatic approval of leave requests", "common.automatic-leave-approval")}
                                        readMore={false}
                                        content={
                                            <div className="flex flex-col gap-3">
                                                <p>{t("common.general-setting-question-57")}.</p>
                                            </div>
                                        }
                                    >
                                        <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                    </DefaultTooltip>
                                </div>

                                {/* RIGHT: Enable + Switch + Reset */}
                                <div className="flex items-center gap-4 shrink-0">

                                    <NormalSwitch
                                        name="allowAutomatiApproval"
                                        checked={formData.allowAutomatiApproval}
                                        onChange={(e) => {
                                            handleInputChange(e);
                                        }}
                                    />

                                    <CustomSecondaryButton
                                        onClick={() =>
                                            handleResetSetting(
                                                getAttrTypeId("Allow automatic approval of leave requests"),
                                                "allowAutomatiApproval"
                                            )
                                        }
                                    >
                                        <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                                    </CustomSecondaryButton>
                                </div>
                            </div>

                            <div className="flex items-center justify-between gap-6">
                                {/* LEFT: Label + Tooltip */}
                                <div className="flex items-center gap-2">
                                    <p className="">
                                        {getSettingTitle("Reset unauthorized absence time", "common.resetlateandearlytime")}
                                    </p>

                                    <DefaultTooltip
                                        title={getSettingTitle("Reset unauthorized absence time", "common.resetlateandearlytime")}
                                        readMore={false}
                                        content={
                                            <div className="flex flex-col gap-3">
                                                <p>{t("common.resetlateandearlytime")}.</p>
                                            </div>
                                        }
                                    >
                                        <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                    </DefaultTooltip>
                                </div>

                                {/* RIGHT: Enable + Switch + Reset */}
                                <div className="flex items-center gap-4 shrink-0">

                                    <NormalSwitch

                                        name="resetlateandearlytime"
                                        checked={formData.resetlateandearlytime}
                                        onChange={(e) => {
                                            handleInputChange(e);
                                        }}
                                    />

                                    <CustomSecondaryButton
                                        sx={{ pointerEvents: "auto" }}
                                        onClick={() =>
                                            handleResetSetting(
                                                getAttrTypeId("Reset unauthorized absence time"),
                                                "resetlateandearlytime"
                                            )
                                        }
                                    >
                                        <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                                    </CustomSecondaryButton>
                                </div>
                            </div>

                            {formData.resetlateandearlytime && (<>
                                <div className='px-4 space-y-2'>
                                    <div className="space-y-2">
                                        <div className="flex md:flex-row flex-col md:items-center items-start gap-4">

                                            {/* LEFT */}
                                            <div className="flex items-center gap-2 shrink-0">
                                                <p>{getSettingTitle("Reset date", "common.resetDate")}</p>
                                                <DefaultTooltip
                                                    title={getSettingTitle("Reset date", "common.resetDate")}
                                                    readMore={false}
                                                    content={
                                                        <div className="flex flex-col gap-3">
                                                            <p>{t("common.resetDate")}.</p>
                                                        </div>
                                                    }
                                                >
                                                    <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                                </DefaultTooltip>
                                            </div>

                                            {/* RIGHT */}
                                            <div className="flex items-center gap-3 flex-1 justify-end">
                                                <CustomSelect
                                                    name="resetDate"
                                                    value={formData.resetDate}
                                                    onChange={handleInputChange}
                                                    options={generateDaysOfYear()}
                                                    className="!w-[200px]"
                                                />

                                                <CustomSecondaryButton
                                                    sx={{ pointerEvents: "auto" }}
                                                    onClick={() =>
                                                        handleResetSetting(
                                                            getAttrTypeId("Reset date"),
                                                            "resetDate"
                                                        )
                                                    }>
                                                    <RefreshCircleIcon20pxSvgV2 />
                                                </CustomSecondaryButton>
                                            </div>

                                        </div>
                                    </div>
                                </div></>)}

                            <div className="flex items-center justify-between gap-6">
                                {/* LEFT: Label + Tooltip */}
                                <div className="flex items-center gap-2">
                                    <p className="">
                                        {getSettingTitle("Automatically Convert Unexcused Leave to Excused Leave", "common.automaticallyConvertUnexcusedLeaveToExcusedLeave")}
                                    </p>

                                    <DefaultTooltip
                                        title={getSettingTitle("Automatically Convert Unexcused Leave to Excused Leave", "common.automaticallyConvertUnexcusedLeaveToExcusedLeave")}
                                        readMore={false}
                                        content={
                                            <div className="flex flex-col gap-3">
                                                <p>{t("common.automaticallyConvertUnexcusedLeaveToExcusedLeave")}.</p>
                                            </div>
                                        }
                                    >
                                        <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                    </DefaultTooltip>
                                </div>

                                {/* RIGHT: Enable + Switch + Reset */}
                                <div className="flex items-center gap-4 shrink-0">

                                    <NormalSwitch
                                        name="automaticallyConvertUnexcusedLeaveToExcusedLeave"
                                        checked={formData.automaticallyConvertUnexcusedLeaveToExcusedLeave}
                                        onChange={(e) => {
                                            handleInputChange(e);
                                        }}
                                    />

                                    <CustomSecondaryButton
                                        sx={{ pointerEvents: "auto" }}
                                        onClick={() =>
                                            handleResetSetting(
                                                getAttrTypeId("Automatically Convert Unexcused Leave to Excused Leave"),
                                                "automaticallyConvertUnexcusedLeaveToExcusedLeave"
                                            )
                                        }
                                    >
                                        <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                                    </CustomSecondaryButton>
                                </div>
                            </div>
                            
                            {formData.automaticallyConvertUnexcusedLeaveToExcusedLeave && (<>
                                <div className='px-4 space-y-2'>
                                    <div className="space-y-2">
                                        <div className="flex md:flex-row flex-col md:items-center items-start gap-4">

                                            {/* LEFT */}
                                            <div className="flex items-center gap-2 shrink-0">
                                                <p>{getSettingTitle("Excluded Leave Types", "common.leaveTypeWithoutPermission")}</p>
                                                <DefaultTooltip
                                                    title={getSettingTitle("Excluded Leave Types", "common.leaveTypeWithoutPermission")}
                                                    readMore={false}
                                                    content={
                                                        <div className="flex flex-col gap-3">
                                                            <p>{t("common.leaveTypeWithoutPermission")}.</p>
                                                        </div>
                                                    }
                                                >
                                                    <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                                </DefaultTooltip>
                                            </div>

                                            {/* RIGHT */}
                                            <div className="flex items-center gap-3 flex-1 justify-end">
                                                <CustomSelect
                                                    name="leaveTypeWithoutPermission"
                                                    value={excludedLeaveTypeSelectValue}
                                                    onChange={handleExcludedLeaveTypeChange}
                                                    options={leaveTypeSelectOptions}
                                                    className="!w-[200px]"
                                                    dataType="leaveType"
                                                />

                                                <CustomSecondaryButton
                                                    sx={{ pointerEvents: "auto" }}
                                                    onClick={() =>
                                                        handleResetSetting(
                                                            getAttrTypeId("Excluded Leave Types"),
                                                            "leaveTypeWithoutPermission"
                                                        )
                                                    }>

                                                    <RefreshCircleIcon20pxSvgV2 />
                                                </CustomSecondaryButton>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="space-y-2">
                                        <div className="flex md:flex-row flex-col md:items-center items-start gap-4">

                                            {/* LEFT */}
                                            <div className="flex items-center gap-2 shrink-0">
                                                <p>{getSettingTitle("Maximum Leave Duration", "common.maximumLeaveDuration")}</p>
                                                <DefaultTooltip
                                                    title={getSettingTitle("Maximum Leave Duration", "common.maximumLeaveDuration")}
                                                    readMore={false}
                                                    content={
                                                        <div className="flex flex-col gap-3">
                                                            <p>{t("common.maximumLeaveDuration")}.</p>
                                                        </div>
                                                    }
                                                >
                                                    <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                                                </DefaultTooltip>
                                            </div>

                                            {/* RIGHT */}
                                            <div className="flex items-center gap-3 flex-1 justify-end">
                                                <CustomTimePickerHaveSecondV2
                                                    hoursLabel={false}
                                                    secondsEnabled={false}
                                                    maxHours={23}
                                                    name="maximumLeaveDuration"
                                                    value={formData.maximumLeaveDuration}
                                                    onTimeChange={(value) => {
                                                        // handleDataChange đã gọi debouncedAutoSave → updateSetting
                                                        handleDataChange("maximumLeaveDuration", value);
                                                    }}
                                                    className="!w-[200px]"
                                                />

                                                <CustomSecondaryButton sx={{ pointerEvents: "auto" }}
                                                    onClick={() =>
                                                        handleResetSetting(
                                                            getAttrTypeId("Maximum Leave Duration"),
                                                            "maximumLeaveDuration"
                                                        )
                                                    }>
                                                    <RefreshCircleIcon20pxSvgV2 />
                                                </CustomSecondaryButton>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </>)}
                        </div>
                    </div>
                </div>

                {/* <div className='bg-[#F9FAFB] p-4 rounded-[16px] space-y-3' data-tour="setting-location">
                    <h2 className='font-semibold'>{t('common.locations')}</h2>

                    <>
                        <StyledDataGrid
                            sx={{
                                height: locations.length > 0 ? 500 : 360,
                                backgroundColor: "#FFFFFF",
                                "& .MuiDataGrid-main": {
                                    backgroundColor: "#FFFFFF",
                                },
                                "& .MuiDataGrid-virtualScroller": {
                                    backgroundColor: "#FFFFFF",
                                },
                                "& .MuiDataGrid-footerContainer": {
                                    backgroundColor: "#FFFFFF",
                                },
                            }}
                            rows={locations}
                            rowCount={locations.length}
                            columns={columnData}
                            loading={gridLoading}
                            slots={{
                                toolbar: templateToolbar,
                                noRowsOverlay: NoRowOverlay,
                                columnsPanel: CustomColumnsPanel,
                            }}
                            hideFooter
                            localeText={tableTranslated}
                        //  columnVisibilityModel={columnVisibilityModel}
                        //  onColumnVisibilityModelChange={handleColumnVisibilityChange}
                        />
                    </>
                </div> */}
            </div>

            <Popper
                open={openAdvanced}
                anchorEl={anchorRefAdvanced.current}
                placement="bottom-start"
                transition
                disablePortal
                className="z-10"
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === "bottom" ? "left top" : "left bottom",
                        }}
                    >
                        <Paper style={{ borderRadius: "8px", }}>
                            <ClickAwayListener onClickAway={handleCloseAdvanced}>
                                <CustomAdvancedMenuList
                                    id="advanced-menu"
                                    aria-labelledby="advanced-button"
                                >
                                    <MenuItem
                                        style={{
                                            borderBottom: "1px solid #E5E7EB",
                                            opacity: "0.5",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <Link>
                                            <ImportIcon16pxSvg />
                                            <p>{t("button.import-data")}</p>
                                        </Link>
                                    </MenuItem>
                                    <MenuItem
                                        style={{
                                            borderBottom: "1px solid #E5E7EB",
                                            opacity: "0.5",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <Link>
                                            <ExportIcon20pxSvg />
                                            <p>{t("button.export-data")}</p>
                                        </Link>
                                    </MenuItem>
                                    <MenuItem
                                        style={{
                                            borderBottom: "1px solid #E5E7EB",
                                            opacity: "0.5",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <Link>
                                            <DeleteIcon16pxSvg className="w-5 h-5" color="#D00D00" />
                                            <p>{t("common.delete-all")}</p>
                                        </Link>
                                    </MenuItem>

                                </CustomAdvancedMenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>

            {addLocationsOpen && <AddLocationDialog onClose={handleCloseAddLocations} onRefresh={handleRefresh} refreshData={refreshData} />}
            {editLocationsOpen && <EditLocationDialog locationData={selectedLocation} onClose={handleCloseEditLocations} onRefresh={handleRefresh} refreshData={refreshData} />}
            {removeLocationOpen && <RemoveLocationDialog locationData={selectedLocation} onClose={handleCloseRemoveLocation} onRefresh={handleRefresh} refreshData={refreshData} />}
        </>
    )
}
